// extracted by mini-css-extract-plugin
module.exports = {"wrapper__title":"GameOver_wrapper__title__2AvFb","wrapper__score":"GameOver_wrapper__score__3yOtn","wrapper__button":"GameOver_wrapper__button__1gihE"};